module.exports = __webpack_public_path__ + "static/media/43.5bd2a3c1.gif";